import React, { Component } from 'react';
import { translate } from 'react-i18next';

import {
  array,
  object,
  oneOfType,
  string,
  number,
  func,
  bool,
} from 'prop-types';
import X from 'wix-ui-icons-common/X';
import Check from 'wix-ui-icons-common/Check';
import More from 'wix-ui-icons-common/More';

import { integrationStatus } from '../../api';
import styles from './styles.scss';

import {
  Page,
  Button,
  Breadcrumbs,
  Loader,
  Text,
  PopoverMenu,
  Badge,
  IconButton,
  Box,
} from 'wix-style-react';

class IntegrationDetailsView extends Component {
  static propTypes = {
    actions: oneOfType([array, object]),
    articleId: string,
    connectedTitle: string,
    disconnectedTitle: string,
    locale: string,
    onActionClick: func,
    onBackClick: func,
    onIntegrationMenuClick: func,
    description: string,
    experiments: object,
    isActionButtonVisible: bool,
    status: string,
    title: string,
    image: string,
    articleHeight: number,
    loading: bool,
    t: func,
    logIntegrationPageView: func,
    maxWidth: number,
  };

  componentDidMount() {
    this.props.logIntegrationPageView();
  }

  getArticleIdFromTranslationKeys() {
    const { locale, t } = this.props;

    const firstTierLanguages = ['de', 'pt', 'fr', 'ru', 'ja', 'it', 'ko', 'es'];

    const documentationUrl = `https://wix.wixanswers.com/apps/widget/v1/wix/3b11861f-3ac4-4c19-8d31-72e395808dac/view/en/article/${t(
      this.props.articleId,
    )}`;

    if (!firstTierLanguages.includes(locale)) {
      return documentationUrl;
    } else {
      return documentationUrl.replace('/en/', `/${locale}/`);
    }
  }

  render() {
    const {
      actions,
      connectedTitle,
      disconnectedTitle,
      articleHeight,
      description,
      image,
      isActionButtonVisible,
      status,
      loading,
      maxWidth,
      onActionClick,
      onBackClick,
      onIntegrationMenuClick,
      t,
      title,
    } = this.props;
    const mainActionButton = (location) => (
      <Button
        dataHook={
          actions
            ? `${actions[0].type}-integration-button`
            : 'setup-integration-button'
        }
        onClick={() => onActionClick(actions[0].handler, location)}
      >
        {t(actions[0].label)}
      </Button>
    );

    const popoverActionButtons = () => (
      <PopoverMenu
        dataHook={`integration-details-popover-menu`}
        placement="left"
        triggerElement={
          <IconButton onClick={() => onIntegrationMenuClick()}>
            <More />
          </IconButton>
        }
      >
        {actions.map((action) => (
          <PopoverMenu.MenuItem
            key={action.type}
            dataHook={`${action.type}-integration-button`}
            onClick={() => onIntegrationMenuClick(action)}
            text={this.props.t(action.label)}
            prefixIcon={action.icon}
            skin={action.skin || 'dark'}
          />
        ))}
      </PopoverMenu>
    );

    const ConnectionStatus = ({ isConnected }) => (
      <div className={styles.connectionStatus}>
        <Badge
          skin={isConnected ? 'success' : 'neutral'}
          type="transparent"
          prefixIcon={isConnected ? <Check size="24px" /> : <X size="20px" />}
          data-hook={`mi-connection-status-${
            isConnected ? 'connected' : 'disabled'
          }`}
        >
          {isConnected
            ? t(connectedTitle || 'details-page.status.connected')
            : t(disconnectedTitle || 'details-page.status.disabled')}
        </Badge>
      </div>
    );

    const actionsBar = (location) => {
      return (
        <div className={styles.actionBarContainer}>
          {status && (
            <ConnectionStatus
              isConnected={status === integrationStatus.CONNECTED}
            />
          )}
          {actions.length === 1
            ? mainActionButton(location)
            : popoverActionButtons()}
        </div>
      );
    };

    return (
      <Page maxWidth={maxWidth} dataHook="integration-details-container">
        <Page.Header
          title={
            <Box width="258px" height="36px">
              <img src={image} alt="" height="100%" />
            </Box>
          }
          subtitle={
            <div className={styles.headerSubtitle}>
              <Text>{t(description)}</Text>
            </div>
          }
          actionsBar={
            isActionButtonVisible &&
            (status !== integrationStatus.NEW &&
            status !== integrationStatus.LOGGEDIN
              ? actionsBar('top')
              : mainActionButton('top'))
          }
          showBackButton
          onBackClicked={onBackClick}
          breadcrumbs={
            <Breadcrumbs
              items={[
                { id: 1, value: `${t('breadcrumbs.main-page')}` },
                { id: 2, value: `${t(title)}`, disabled: true },
              ]}
              activeId={2}
              onClick={onBackClick}
            />
          }
        />
        <Page.Content>
          <div className={styles.pageContent}>
            {loading && (
              <div className={styles.loaderContainer}>
                <div className={styles.loader}>
                  <Loader data-hook="details-page-loader" />
                </div>
              </div>
            )}
            <div className={styles.contentContainer}>
              <iframe
                title="article"
                data-hook="article-iframe"
                className={styles.documentationIframe}
                src={this.getArticleIdFromTranslationKeys()}
                height={articleHeight + 'px'}
                scrolling="yes"
              />
            </div>
            {!loading && actions.length === 1 && (
              <div className={styles.actionButton}>
                {mainActionButton('bottom')}
              </div>
            )}
          </div>
        </Page.Content>
      </Page>
    );
  }
}

export default translate()(IntegrationDetailsView);
